<template>
  <section class="container pb-8" v-if="isReedy">
    <div class="row">
      <!-- 課程影片 -->
      <div class="col-12 col-md-8 pr-md-0 mb-5 mb-md-0">
        <h4 class="bg-accent text-center text-white py-1 py-lg-3">{{ data.courseName }}</h4>
        <div class="bg-outer border-shadow"
          :style="`--content:'${cssContent}'`">
          <div
            class="videoWrapper videoWrapper100 js-videoWrapper bg-image"
            :style="{
              backgroundImage: 'url(' + data.contentImagePath + ')',
            }"
          >
            <div class="videoIframe js-videoIframe" v-show="hasVideo">
              <video id="player" ref="courseVideo" playsinline>
              </video>
            </div>
          </div>
        </div>
      </div>
      <!-- 課程觀看列表 -->
      <div class="col-md-4 d-block d-md-flex flex-column justify-content-between pl-md-0">
        <h5 class="gotoclass-title bg-light text-center py-lg-3">課程觀看列表</h5>
        <div class="row">
          <div class="col-6 pr-0">
            <a
              class="btn btn-sm w-100 btn-primary "
              :class="{ 'btn-light': courseType !== 1 }"
              @click.prevent="courseType = 1"
            >
              <i class="fa fa-book mr-2" aria-hidden="true"></i>課程列表
            </a>
          </div>
          <div class="col-6 pl-0">
            <a
              class="btn btn-sm w-100 btn-primary "
              :class="{ 'btn-light': courseType !== 2 }"
              @click.prevent="courseType = 2"
            >
              <i class="fa fa-heart mr-2" aria-hidden="true"></i>我的最愛
            </a>
          </div>
        </div>
        <ul class="gotolist cs-side justify-self-stretch bg-light border-shadow" data-style="2">
          <template v-if="courseData.length">
            <li
              class="side__box"
              :class="{ active: index === 0 }"
              v-for="(item, index) in courseData"
              :key="`${index}-${item.subjectId}`"
              @click="ToggleClass($event)"
            >
              <div class="gotolist__head side__title">
                <div class="gotolist__head-td">
                  <i class="fa fa-th pr-2" aria-hidden="true"></i> {{ item.groupName }}
                </div>
                <div class="gotolist__head-td">{{ item.buyCourseClassRoomList.length }} 堂</div>
                <div class="gotolist__head-td">
                  <i class="fa fa-chevron-up icon-icon_arrow" aria-hidden="true"></i>
                </div>
              </div>
              <ul class="gotolist__content side__content">
                <li
                  style="position: relative;"
                  :style="{
                    backgroundColor: item2.classCode === currentPlay.classCode ? '#e1e1e1' : '',
                  }"
                  v-for="(item2, index2) in item.buyCourseClassRoomList"
                  :key="`${index2}-${item2.classId}`"
                >
                  <i
                    class="fa fa-play-circle playing"
                    aria-hidden="true"
                    v-if="item2.classCode === currentPlay.classCode"
                  ></i>
                  <a
                    href="#"
                    class="js-videoPoster "
                    :class="{ comingsoon: item2.hasVideo === false }"
                    @click.prevent="OpenVideo(item2)"
                  >
                    {{ item2.className }}({{ item2.teacherName }})
                  </a>
                  <div class="LearningInfo">
                    <div>
                      <i
                        class="fa fa-check-circle"
                        :style="{ color: item2.isLook ? '#cccf2d' : '#c0c4cc' }"
                      ></i>
                    </div>
                    <div
                      :class="{ comingsoon: item2.hasVideo === false }"
                      :style="{ color: item2.hasVideo ? '#e6a23c' : '' }"
                    >
                      觀看紀錄:({{ item2.time | secConvertTime }})
                    </div>
                    <div>
                      <a
                        href="#"
                        :class="{
                          comingsoon: item2.hasVideo === false,
                          'text-primary': item2.hasVideo === true,
                        }"
                        @click.prevent="
                          () => {
                            if (item2.hasVideo === true) handleOpenNode(item2);
                          }
                        "
                      >
                        筆記({{ item2.videoNotesCount }})
                      </a>
                    </div>
                    <div>
                      <a href="#" @click.prevent="handleFavorite(item2)">
                        <i
                          class="fa fa-heart"
                          :style="{ color: item2.isFavorite ? '#ff6363' : '#c0c4cc' }"
                        />
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
            </li>
          </template>
          <template v-else>
            <li class="side__box py-2" style="text-align: center;">暫無資料</li>
          </template>
        </ul>
        <div class="row">
          <div class="col-4 pr-0">
            <a
              v-if="currentPlay.classLecturePath !== ''"
              class="btn btn-hover-primary text-white border-right rounded-0 w-100 py-2"
              :href="currentPlay.classLecturePath"
              target="_blank"
              >補充下載</a
            >
            <a
              v-else
              class="btn btn-hover-primary text-white border-right rounded-0 w-100 py-2"
              @click.prevent="ShowMsgForNotDownloadFile"
              >暫無補充</a
            >
          </div>
          <div class="col-4 px-0">
            <a
              v-if="currentPlay.classNotePath !== ''"
              class="btn btn-hover-primary text-white border-right rounded-0 w-100 py-2"
              :href="currentPlay.classNotePath"
              target="_blank"
              >筆記下載</a
            >
            <a
              v-else
              class="btn btn-hover-primary text-white border-right rounded-0 w-100 py-2"
              @click.prevent="ShowMsgForNotDownloadFile"
              >暫無筆記</a
            >
          </div>
          <div class="col-4 pl-0">
            <a
              class="btn btn-hover-primary text-white border-right rounded-0 w-100 py-2"
              @click="handleOpenNode()"
              >+筆記</a
            >
          </div>
        </div>
      </div>
      <PlaybackDiagnosticsPanel
        v-if="playbackDiagnosticsEnabled"
        class="col-12"
        :diagnostics="playbackDiagnostics"
        @clear="clearPlaybackDiagnosticHistory"
      />
      <div class="col-12">
        <p>
          ※若您遇到課程播放的問題，請先到「
          <router-link to="/novices/question">
            常見問題
          </router-link>
          」參考相關訊息
        </p>

        <!-- template 暫時加入，重現後刪除 -->
        <!-- <button
          style="position:fixed;bottom:10px;right:10px;z-index:9999;"
          @click="debugSimulateError"
        >模擬 HLS 錯誤</button> -->
      </div>
      <!-- 課程相關資訊 -->
      <CourseInfon :courseInfo="data" :learning="true" />
      <Notes
        :showModel.sync="showNote"
        :code="currentPlay.classCode"
        :classItem="currentPlay.className"
        :videoTime="currentTime"
        :course="data.courseName"
        @changeCurrentTime="changeCurrentTime"
        @changeNoteCount="changeNoteCount"
        @pauseVideo="handlePauseVideo"
      />
    </div>
  </section>
</template>

<script>
import Plyr from 'plyr';
import Hls from 'hls.js';
import 'plyr/dist/plyr.css';
import {
  GetBuyCourseContentByMember,
  GetVideoTime,
  SetVideoTime,
  GetVideoCookies,
} from '@/api/BuyCourseApi';
import { AddToFavorite, RemoveToFavorite } from '@/api/MemberRecordApi';

import CourseInfon from '@/components/CourseInfon.vue';
import Notes from '@/components/Learning/Notes.vue';
import PlaybackDiagnosticsPanel from '@/components/Learning/PlaybackDiagnosticsPanel.vue';
import {
  showPlaybackDiagnosis as displayPlaybackDiagnosis,
  showPlaybackStatusNotice as displayPlaybackStatusNotice,
} from '@/lib/PlaybackDiagnosis';
import {
  createHlsErrorDiagnostic,
  createPlaybackDiagnosticSnapshot,
  getCloudFrontPolicyExpiration,
} from '@/lib/PlaybackDiagnostics';

const PLAYBACK_NETWORK_NOTICE_DELAY = 5000;
const PLAYBACK_LIGHT_RECOVERY_DELAY = 20000;
const PLAYBACK_LIGHT_RECOVERY_COOLDOWN = 30000;
const MAX_HLS_INITIALIZATION_RETRIES = 2;
const HLS_INITIALIZATION_RETRY_DELAYS = [1000, 2500];
/* global $ */

export default {
  props: ['currentPage'],
  components: {
    CourseInfon,
    Notes,
    PlaybackDiagnosticsPanel,
  },
  data() {
    // 建立你的初始化 model data
    return {
      // 真實觀看時間相關
      realWatchStartTime: null,
      realWatchSaveTimer: null,

      // 播放器相關
      player: null,
      hasVideo: false,
      hasCaption: false,
      hasError: false,
      isHandlingPlay: false,

      // 播放意圖：用來區分「使用者主動暫停」與瀏覽器因卡頓／切背景造成的暫停。
      playbackIntended: false,

      // 前景恢復與媒體資源回收狀態。
      wasPlaying: false,
      mediaWasEmptied: false,
      mediaResetIgnoreEmptiedUntil: 0,
      visibilityRecoveryTimer: null,
      visibilityProgressTimer: null,

      // 長時間沒有播放進度時的提示與低干預恢復。
      stallRecoveryTimer: null,
      playbackNetworkNoticeTimer: null,
      playbackNetworkNoticeInstance: null,
      playbackNetworkNoticeCooldownUntil: 0,
      playbackProgressWatchTimer: null,
      playbackProgressWatchLastTime: 0,
      playbackProgressWatchStalledSince: null,
      playbackLightRecoveryTimer: null,
      lastPlaybackLightRecoveryAt: 0,
      playbackPauseIntentTimer: null,

      // 完整重建、錯誤診斷與切課非同步競態防護。
      isRecoveringPlayback: false,
      isCleaningUp: false,
      resumeAfterRecovery: false,
      lastPlaybackRecoveryAt: 0,
      playbackFailureTimer: null,
      playbackDiagnosisShown: false,
      videoOpenRequestId: 0,

      // HLS manifest 初始化失敗只做有限次重試，避免無限重建播放器。
      hlsInitializationRetryCount: 0,
      hlsInitializationRetryTimer: null,

      // UAT 畫面診斷只保存在目前頁面記憶體，不會送往後端。
      playbackDiagnosticsEnabled: false,
      playbackDiagnosticsTimer: null,
      playbackDiagnosticEventId: 0,
      playbackDiagnostics: {
        live: null,
        incident: null,
        events: [],
        authorization: {
          status: '尚未取得',
          refreshedAt: null,
          expiresAt: null,
          validitySeconds: null,
          classCode: '',
          error: '',
        },
        lastHlsError: null,
      },
      currentTime: 0,
      keepTime: 0,

      // UI 狀態相關
      showNote: 0,
      courseType: 1,
      isReedy: false,

      // 當前播放相關
      currentPlay: '',
      subject: {},

      // 字幕相關
      captionsSrc: '',
      cssContent: '觀看者',

      // 播放器設定
      videoSource: [
        { src: '_720p.m3u8', size: 720 },
        { src: '_1080.m3u8', size: 1080 },
      ],
      options: {
        clickToPlay: false,
        playsinline: true,
        controls: [
          'play-large', 'rewind', 'play', 'fast-forward', 'progress',
          'current-time', 'duration', 'mute', 'volume', 'settings', 'fullscreen', 'pip',
        ],
        captions: { active: true, language: 'auto', update: true },
        settings: ['quality', 'speed'],
        quality: { default: 720, options: [1080, 720] },
        speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] },
        fullscreen: {
          enabled: true, fallback: true, iosNative: false, container: null,
        },
      },
      // 課程資料
      data: {
        courseId: 0,
        courseName: '',
        examId: 0,
        examName: '',
        categoryId: 0,
        categoryName: '',
        roomId: 0,
        roomName: '',
        courseOriPrice: 0,
        coursePrice: 0,
        courseContent: '',
        contentImagePath: '',
        courseYoutubeUrl: '',
        courseViewStartDate: this.$moment(new Date('9999/12/31')),
        courseViewEndDate: this.$moment(new Date('9999/12/31')),
        classRoomList: [{
          subjectId: 0,
          subjectName: '',
          buyCourseClassRoomList: [{
            classId: 0,
            className: '',
            teacherId: 0,
            teacherName: '',
          }],
        }],
      },
    };
  },
  created() {
    this.initializePlaybackDiagnostics();
    this.GetBuyCourseContent();
  },
  mounted() {
    // 設定觀看者帳號在字幕上
    this.initializeCaptions();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.startPlaybackDiagnostics();
  },
  // 組件銷毀時清理
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.stopPlaybackDiagnostics();
    this.videoOpenRequestId += 1;

    // 離開的時候需要立刻紀錄觀看時間，若有觀看中的話
    if (this.realWatchSaveTimer && this.currentPlay.classCode) {
      this.SetVideoTime(
        this.currentPlay.classCode,
        Math.floor(this.player ? this.player.currentTime : 0),
        'LeavePage',
      );
    }

    this.cleanup();
  },
  beforeRouteLeave(to, form, next) {
    if (document.pictureInPictureElement) {
      document.exitPictureInPicture();
    }

    next();
  },
  computed: {
    courseData() {
      const courseData = this._.reduce(
        this.data.newClassRoomList,
        (result, o) => {
          // 課程分類透過深拷貝，避免因為filter過濾後會影響到原始資料
          // 課程列表內容則不使用深拷貝，這樣才能保持資料同步(當在不同列表的時候，增加/移除我的最愛才可以同步處理)
          const roomLis = { ...o };
          roomLis.buyCourseClassRoomList = this._.filter(o.buyCourseClassRoomList, (i) => {
            if (this.courseType === 1) return true;
            if (i.isFavorite) return true;
            return false;
          });
          if (roomLis.buyCourseClassRoomList.length > 0) result.push(roomLis);
          return result;
        },
        [],
      );

      return courseData;
    },
  },
  methods: {
    // ==================== 初始化和清理 ====================
    initializePlaybackDiagnostics() {
      // 診斷面板只能由建置環境開啟，網址參數不得在其他環境繞過此限制。
      this.playbackDiagnosticsEnabled = process.env.VUE_APP_DEV === '1';
      if (this.playbackDiagnosticsEnabled) {
        this.recordPlaybackDiagnosticEvent('diagnostics-enabled', '開始收集頁面內診斷資料');
      }
    },

    startPlaybackDiagnostics() {
      if (!this.playbackDiagnosticsEnabled || this.playbackDiagnosticsTimer) return;
      this.updatePlaybackDiagnosticSnapshot();
      this.playbackDiagnosticsTimer = setInterval(() => {
        this.updatePlaybackDiagnosticSnapshot();
      }, 1000);
    },

    stopPlaybackDiagnostics() {
      if (this.playbackDiagnosticsTimer) {
        clearInterval(this.playbackDiagnosticsTimer);
        this.playbackDiagnosticsTimer = null;
      }
    },

    buildPlaybackDiagnosticSnapshot() {
      return createPlaybackDiagnosticSnapshot({
        video: this.getVideoElement(),
        hls: window.hls || null,
        course: this.currentPlay,
        authorization: this.playbackDiagnostics.authorization,
        lastHlsError: this.playbackDiagnostics.lastHlsError,
        playbackIntended: this.playbackIntended,
        hasError: this.hasError,
        mediaWasEmptied: this.mediaWasEmptied,
        isRecovering: this.isRecoveringPlayback,
        stalledSince: this.playbackProgressWatchStalledSince,
      });
    },

    updatePlaybackDiagnosticSnapshot() {
      if (!this.playbackDiagnosticsEnabled) return;
      this.playbackDiagnostics = {
        ...this.playbackDiagnostics,
        live: this.buildPlaybackDiagnosticSnapshot(),
      };
    },

    recordPlaybackDiagnosticEvent(type, detail = '', options = {}) {
      if (!this.playbackDiagnosticsEnabled) return;

      const snapshot = this.buildPlaybackDiagnosticSnapshot();
      const previousEvent = this.playbackDiagnostics.events[0];
      const isDuplicate = previousEvent
        && previousEvent.type === type
        && Date.now() - Date.parse(previousEvent.at) < 250;
      if (isDuplicate) {
        this.playbackDiagnostics = {
          ...this.playbackDiagnostics,
          live: snapshot,
        };
        return;
      }

      this.playbackDiagnosticEventId += 1;
      const event = {
        id: this.playbackDiagnosticEventId,
        at: new Date().toISOString(),
        type,
        detail: detail || '',
      };
      const events = [event, ...this.playbackDiagnostics.events].slice(0, 20);
      const incident = options.incident
        ? { event, snapshot }
        : this.playbackDiagnostics.incident;

      this.playbackDiagnostics = {
        ...this.playbackDiagnostics,
        live: snapshot,
        incident,
        events,
      };
    },

    clearPlaybackDiagnosticHistory() {
      this.playbackDiagnostics = {
        ...this.playbackDiagnostics,
        incident: null,
        events: [],
        lastHlsError: null,
      };
      this.updatePlaybackDiagnosticSnapshot();
    },

    updatePlaybackAuthorizationDiagnostic({
      status,
      classCode,
      expiresAt = null,
      error = '',
    }) {
      if (!this.playbackDiagnosticsEnabled) return;

      const refreshedAt = new Date().toISOString();
      const expiresAtMs = expiresAt ? Date.parse(expiresAt) : NaN;
      const validitySeconds = Number.isFinite(expiresAtMs)
        ? Math.floor((expiresAtMs - Date.now()) / 1000)
        : null;
      this.playbackDiagnostics = {
        ...this.playbackDiagnostics,
        authorization: {
          status,
          refreshedAt,
          expiresAt,
          validitySeconds,
          classCode,
          error,
        },
      };
      this.updatePlaybackDiagnosticSnapshot();
    },

    captureHlsErrorDiagnostic(data) {
      if (!this.playbackDiagnosticsEnabled) return;

      const hlsError = createHlsErrorDiagnostic(data);
      this.playbackDiagnostics = {
        ...this.playbackDiagnostics,
        lastHlsError: hlsError,
      };
      const detail = [
        hlsError.type,
        hlsError.details,
        hlsError.event ? `event=${hlsError.event}` : '',
        hlsError.responseCode ? `HTTP ${hlsError.responseCode}` : '',
        hlsError.fatal ? 'fatal' : '',
        hlsError.message,
      ].filter(Boolean).join(' / ');
      this.recordPlaybackDiagnosticEvent('hls-error', detail, {
        incident: hlsError.fatal || hlsError.responseCode === 401 || hlsError.responseCode === 403,
      });
    },

    // 設定觀看者帳號在字幕上
    initializeCaptions() {
      this.cssContent = window.btoa(unescape(this.$UserId));
      const captionsText = `WEBVTT\n\n00:00:00.000 --> 23:00:00.000\n${this.$UserAccount}`;
      const captionsBase64 = window.btoa(unescape(encodeURIComponent(captionsText)));
      this.captionsSrc = `data:@file/octet-stream;base64,${captionsBase64}`;
    },

    // 取得目前課程播放器實際使用的原生 video 元素
    getVideoElement() {
      // Plyr destroy/rebuild 後，Vue ref 可能短暫指向舊節點；每次優先找元件目前 DOM 的 video。
      const currentVideo = this.$el && this.$el.querySelector
        ? this.$el.querySelector('video')
        : null;
      if (currentVideo) return currentVideo;
      if (this.player && this.player.media) return this.player.media;
      return this.$refs.courseVideo || null;
    },

    /**
     * iPhone／iPad 優先交給 WebKit 原生 HLS，避免新版 iPad 因支援 MSE 而誤走舊版 HLS.js。
     * MacIntel + 多點觸控用來涵蓋 iPadOS 的桌面版 user agent。
     */
    shouldUseNativeHls(video = this.getVideoElement()) {
      if (!video || typeof video.canPlayType !== 'function') return false;

      const userAgent = navigator.userAgent || '';
      const platform = navigator.platform || '';
      const isIOS = /iPad|iPhone|iPod/i.test(userAgent)
        || (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      if (!isIOS) return false;

      return !!(
        video.canPlayType('application/vnd.apple.mpegurl')
        || video.canPlayType('application/x-mpegURL')
      );
    },

    /**
     * Plyr 會把使用者選擇的倍速存進 localStorage.plyr.speed。
     * 原生 HLS 切換來源前先讀出來，避免 iOS 呼叫 media.load() 時把倍速重設成 1。
     */
    getStoredPlaybackSpeed() {
      const fallbackSpeed = Number(this.options.speed.selected) || 1;

      try {
        const storedOptions = JSON.parse(window.localStorage.getItem('plyr') || '{}');
        const storedSpeed = Number(storedOptions.speed);
        const supportedSpeeds = this.options.speed.options.map((speed) => Number(speed));
        return Number.isFinite(storedSpeed) && supportedSpeeds.includes(storedSpeed)
          ? storedSpeed
          : fallbackSpeed;
      } catch (error) {
        return fallbackSpeed;
      }
    },

    /**
     * player.source 會重建原生 video；等新來源 metadata 就緒後再套回切換前的倍速。
     * player identity 檢查可避免舊影片的延遲事件誤改到下一堂課。
     */
    restorePlaybackSpeedAfterSourceChange(player, playbackSpeed) {
      if (!player || !Number.isFinite(playbackSpeed)) return;
      const targetPlayer = player;

      const applyPlaybackSpeed = () => {
        if (this.player !== targetPlayer || !targetPlayer.media) return;
        targetPlayer.speed = playbackSpeed;
      };

      if (targetPlayer.media && targetPlayer.media.readyState >= 1) {
        setTimeout(applyPlaybackSpeed, 0);
      } else {
        targetPlayer.once('loadedmetadata', applyPlaybackSpeed);
      }
    },

    // Plyr/HLS destroy 不一定會清掉原生 video 的 MediaSource。
    // 明確移除 src 並呼叫 load，讓瀏覽器釋放舊課程的下載器、解碼器與緩衝區。
    resetMediaElement(video) {
      if (!video) return;

      const mediaElement = video;
      this.mediaResetIgnoreEmptiedUntil = Date.now() + 1000;
      try {
        mediaElement.pause();
        if ('srcObject' in mediaElement && mediaElement.srcObject) {
          mediaElement.srcObject = null;
        }
        mediaElement.removeAttribute('src');
        Array.from(mediaElement.querySelectorAll('source')).forEach((source) => {
          if (source.parentNode) source.parentNode.removeChild(source);
        });
        mediaElement.load();
      } catch (error) {
        // DOM 已被 Plyr 替換時可能無法再操作；後續仍會重建目前畫面上的 video。
      }
    },

    // 清除播放器異常偵測的延遲工作
    clearPlaybackRecoveryTimers() {
      this.stopPlaybackProgressWatch();

      if (this.visibilityRecoveryTimer) {
        clearTimeout(this.visibilityRecoveryTimer);
        this.visibilityRecoveryTimer = null;
      }
      if (this.visibilityProgressTimer) {
        clearTimeout(this.visibilityProgressTimer);
        this.visibilityProgressTimer = null;
      }
      if (this.stallRecoveryTimer) {
        clearTimeout(this.stallRecoveryTimer);
        this.stallRecoveryTimer = null;
      }
      if (this.playbackNetworkNoticeTimer) {
        clearTimeout(this.playbackNetworkNoticeTimer);
        this.playbackNetworkNoticeTimer = null;
      }
      if (this.playbackNetworkNoticeInstance) {
        this.playbackNetworkNoticeInstance.close();
        this.playbackNetworkNoticeInstance = null;
      }
      if (this.playbackFailureTimer) {
        clearTimeout(this.playbackFailureTimer);
        this.playbackFailureTimer = null;
      }
      if (this.playbackLightRecoveryTimer) {
        clearTimeout(this.playbackLightRecoveryTimer);
        this.playbackLightRecoveryTimer = null;
      }
    },

    clearHlsInitializationRetryTimer() {
      if (this.hlsInitializationRetryTimer) {
        clearTimeout(this.hlsInitializationRetryTimer);
        this.hlsInitializationRetryTimer = null;
      }
    },

    // 頁面切到背景時只記錄狀態，不立即重載影片
    handleVisibilityChange() {
      this.recordPlaybackDiagnosticEvent(
        document.hidden ? 'visibility-hidden' : 'visibility-visible',
        `visibilityState=${document.visibilityState}`,
      );
      const video = this.getVideoElement();
      if (!video || !this.hasVideo || this.isCleaningUp) return;

      if (document.hidden) {
        this.clearPlaybackRecoveryTimers();
        this.wasPlaying = !video.paused && !video.ended;
        return;
      }

      if (this.wasPlaying || (this.mediaWasEmptied && this.playbackIntended)) {
        // 保留一秒寬限期，讓瀏覽器先自行恢復媒體資源
        if (this.visibilityRecoveryTimer) clearTimeout(this.visibilityRecoveryTimer);
        this.visibilityRecoveryTimer = setTimeout(() => {
          this.visibilityRecoveryTimer = null;
          this.checkPlaybackAfterVisibility();
        }, 1000);
      }
    },

    // 前景恢復後確認影片是否真的仍在播放
    checkPlaybackAfterVisibility() {
      const video = this.getVideoElement();
      if (
        document.hidden
        || !video
        || !this.hasVideo
        || (!this.wasPlaying && !(this.mediaWasEmptied && this.playbackIntended))
        || this.isCleaningUp
        || this.isRecoveringPlayback
      ) return;

      if (video.readyState < 3 || video.ended) {
        this.recoverPlayback('visibility');
        return;
      }

      const startTime = video.currentTime;
      if (this.visibilityProgressTimer) clearTimeout(this.visibilityProgressTimer);
      this.visibilityProgressTimer = setTimeout(() => {
        this.visibilityProgressTimer = null;
        const currentVideo = this.getVideoElement();
        if (
          document.hidden
          || !currentVideo
          || !this.hasVideo
          || (!this.wasPlaying && !(this.mediaWasEmptied && this.playbackIntended))
          || this.isCleaningUp
          || this.isRecoveringPlayback
        ) return;

        const hasProgressed = currentVideo.currentTime > startTime + 0.1;
        if (
          currentVideo.readyState < 3
          || currentVideo.paused
          || currentVideo.ended
          || !hasProgressed
        ) {
          this.recoverPlayback('visibility');
        } else {
          this.mediaWasEmptied = false;
        }
      }, 500);
    },

    // 媒體資源被瀏覽器回收時，記錄訊號並等待適當時機恢復
    handleMediaEmptied() {
      // cleanup() 主動呼叫 load() 也會觸發 emptied；這不是播放故障，不可啟動恢復流程。
      if (
        Date.now() < this.mediaResetIgnoreEmptiedUntil
        || this.isCleaningUp
        || !this.hasVideo
      ) return;

      this.recordPlaybackDiagnosticEvent('emptied', '瀏覽器已清空目前媒體資源', {
        incident: true,
      });
      this.mediaWasEmptied = true;
      const playbackWasActive = this.playbackIntended
        || this.wasPlaying
        || (this.isPlayerReady() && this.player.playing && !this.player.paused);
      if (playbackWasActive && !document.hidden) {
        this.wasPlaying = true;
        if (this.visibilityRecoveryTimer) clearTimeout(this.visibilityRecoveryTimer);
        this.visibilityRecoveryTimer = setTimeout(() => {
          this.visibilityRecoveryTimer = null;
          this.checkPlaybackAfterVisibility();
        }, 1000);
      }
    },

    // 只在持續卡住一段時間後才進行恢復，避免正常短暫 buffering 被誤判
    scheduleStallRecovery(reason = 'stall') {
      // waiting/stalled 是瀏覽器在緩衝不足時的正常訊號，不能因此重建課程。
      // 保留原本行為：讓 HLS 繼續下載，影片必要時只呈現緩衝狀態。
      if (reason === 'waiting' || reason === 'stalled') {
        this.schedulePlaybackNetworkNotice(reason);
        this.schedulePlaybackLightRecovery();
        return;
      }

      const video = this.getVideoElement();
      if (
        !video
        || document.hidden
        || this.isCleaningUp
        || this.isRecoveringPlayback
        || (video.paused && !this.playbackIntended)
        || video.ended
      ) return;

      if (this.stallRecoveryTimer) clearTimeout(this.stallRecoveryTimer);
      const startTime = video.currentTime;
      this.stallRecoveryTimer = setTimeout(() => {
        this.stallRecoveryTimer = null;
        const currentVideo = this.getVideoElement();
        if (
          !currentVideo
          || document.hidden
          || this.isCleaningUp
          || this.isRecoveringPlayback
          || currentVideo.ended
        ) return;

        const hasProgressed = currentVideo.currentTime > startTime + 0.1;
        if (
          currentVideo.readyState < 3
          || (currentVideo.paused && this.playbackIntended)
          || !hasProgressed
        ) {
          this.recoverPlayback(reason);
        }
      }, 5000);
    },

    schedulePlaybackNetworkNotice(reason = 'waiting') {
      const video = this.getVideoElement();
      if (
        !video
        || document.hidden
        || this.isCleaningUp
        || this.isRecoveringPlayback
        || (video.paused && !this.playbackIntended)
        || video.ended
      ) return;

      if (this.playbackNetworkNoticeTimer) clearTimeout(this.playbackNetworkNoticeTimer);
      const startTime = video.currentTime;
      this.playbackNetworkNoticeTimer = setTimeout(() => {
        this.playbackNetworkNoticeTimer = null;
        const currentVideo = this.getVideoElement();
        if (
          !currentVideo
          || document.hidden
          || this.isCleaningUp
          || (currentVideo.paused && !this.playbackIntended)
          || currentVideo.ended
        ) return;

        const hasProgressed = currentVideo.currentTime > startTime + 0.1;
        if (!hasProgressed) {
          this.showPlaybackNetworkNoticeIfAllowed(currentVideo, reason);
        }
      }, PLAYBACK_NETWORK_NOTICE_DELAY);
    },

    // 一般緩衝不重建播放器；只有長時間完全沒有進度時才喚醒既有 HLS 載入。
    schedulePlaybackLightRecovery() {
      const video = this.getVideoElement();
      if (
        !video
        || !this.isHlsReady()
        || document.hidden
        || this.isCleaningUp
        || this.isRecoveringPlayback
        || (!this.playbackIntended && video.paused)
        || video.ended
        || this.playbackLightRecoveryTimer
        || Date.now() - this.lastPlaybackLightRecoveryAt
          < PLAYBACK_LIGHT_RECOVERY_COOLDOWN
      ) return;

      const startTime = video.currentTime;
      this.playbackLightRecoveryTimer = setTimeout(() => {
        this.playbackLightRecoveryTimer = null;
        const currentVideo = this.getVideoElement();
        const { hls } = window;
        if (
          !currentVideo
          || !hls
          || document.hidden
          || this.isCleaningUp
          || this.isRecoveringPlayback
          || (!this.playbackIntended && currentVideo.paused)
          || currentVideo.ended
          || currentVideo.currentTime > startTime + 0.1
        ) return;

        this.lastPlaybackLightRecoveryAt = Date.now();
        try {
          if (!hls.media) hls.attachMedia(currentVideo);
          hls.startLoad(currentVideo.currentTime);
        } catch (error) {
          // 輕量喚醒失敗時保留原播放器，交由既有錯誤事件與提示流程處理。
        }
      }, PLAYBACK_LIGHT_RECOVERY_DELAY);
    },

    startPlaybackProgressWatch() {
      const video = this.getVideoElement();
      if (!video || this.playbackProgressWatchTimer) return;

      this.playbackProgressWatchLastTime = video.currentTime;
      this.playbackProgressWatchStalledSince = null;
      this.playbackProgressWatchTimer = setInterval(() => {
        const currentVideo = this.getVideoElement();
        if (
          !currentVideo
          || document.hidden
          || this.isCleaningUp
          || (currentVideo.paused && !this.playbackIntended)
          || currentVideo.ended
        ) {
          this.stopPlaybackProgressWatch();
          return;
        }

        const hasProgressed = currentVideo.currentTime
          > this.playbackProgressWatchLastTime + 0.1;
        if (hasProgressed) {
          this.playbackProgressWatchLastTime = currentVideo.currentTime;
          this.playbackProgressWatchStalledSince = null;
          return;
        }

        if (this.playbackProgressWatchStalledSince === null) {
          this.playbackProgressWatchStalledSince = Date.now();
          return;
        }

        if (
          Date.now() - this.playbackProgressWatchStalledSince >= PLAYBACK_NETWORK_NOTICE_DELAY
        ) {
          this.schedulePlaybackLightRecovery();
          if (
            !this.playbackNetworkNoticeInstance
            && Date.now() >= this.playbackNetworkNoticeCooldownUntil
          ) {
            this.recordPlaybackDiagnosticEvent(
              'progress-stopped',
              `currentTime=${currentVideo.currentTime.toFixed(2)}`,
              { incident: true },
            );
            this.showPlaybackNetworkNoticeIfAllowed(currentVideo, 'waiting');
          }
        }
      }, 1000);
    },

    stopPlaybackProgressWatch() {
      if (this.playbackProgressWatchTimer) {
        clearInterval(this.playbackProgressWatchTimer);
        this.playbackProgressWatchTimer = null;
      }
      this.playbackProgressWatchLastTime = 0;
      this.playbackProgressWatchStalledSince = null;
    },

    showPlaybackNetworkNoticeIfAllowed(video, reason = 'waiting') {
      if (
        this.playbackNetworkNoticeInstance
        || Date.now() < this.playbackNetworkNoticeCooldownUntil
      ) return;

      this.playbackNetworkNoticeCooldownUntil = Date.now() + 30000;
      this.playbackNetworkNoticeInstance = displayPlaybackStatusNotice(this, {
        video: video || this.getVideoElement(),
        reason,
        mediaWasEmptied: this.mediaWasEmptied,
      });
    },

    handleMediaWaiting() {
      this.recordPlaybackDiagnosticEvent('waiting', 'video waiting event');
      this.scheduleStallRecovery('waiting');
    },

    handleMediaStalled() {
      this.recordPlaybackDiagnosticEvent('stalled', 'video stalled event', {
        incident: true,
      });
      this.scheduleStallRecovery('stalled');
    },

    handlePlaybackHealthy() {
      this.recordPlaybackDiagnosticEvent('playing', '影片時間開始前進');
      this.playbackIntended = true;
      this.hasError = false;
      if (this.playbackPauseIntentTimer) {
        clearTimeout(this.playbackPauseIntentTimer);
        this.playbackPauseIntentTimer = null;
      }
      if (this.stallRecoveryTimer) {
        clearTimeout(this.stallRecoveryTimer);
        this.stallRecoveryTimer = null;
      }
      if (this.playbackNetworkNoticeTimer) {
        clearTimeout(this.playbackNetworkNoticeTimer);
        this.playbackNetworkNoticeTimer = null;
      }
      if (this.playbackFailureTimer) {
        clearTimeout(this.playbackFailureTimer);
        this.playbackFailureTimer = null;
      }
      if (this.playbackLightRecoveryTimer) {
        clearTimeout(this.playbackLightRecoveryTimer);
        this.playbackLightRecoveryTimer = null;
      }
      if (this.playbackNetworkNoticeInstance) {
        this.playbackNetworkNoticeInstance.close();
        this.playbackNetworkNoticeInstance = null;
      }
      this.startPlaybackProgressWatch();
    },

    scheduleHlsInitializationRetry(hls, reason) {
      if (
        !hls
        || window.hls !== hls
        || this.isCleaningUp
        || !this.currentPlay.classCode
        || this.hlsInitializationRetryTimer
      ) return;

      if (this.hlsInitializationRetryCount >= MAX_HLS_INITIALIZATION_RETRIES) {
        this.recordPlaybackDiagnosticEvent('recovery-failed', reason, {
          incident: true,
        });
        this.showPlaybackDiagnosis(reason);
        return;
      }

      const retryClassCode = this.currentPlay.classCode;
      const retryDelay = HLS_INITIALIZATION_RETRY_DELAYS[
        this.hlsInitializationRetryCount
      ];
      this.hlsInitializationRetryCount += 1;
      this.hlsInitializationRetryTimer = setTimeout(() => {
        this.hlsInitializationRetryTimer = null;
        if (
          window.hls !== hls
          || this.isCleaningUp
          || this.currentPlay.classCode !== retryClassCode
        ) return;

        try {
          this.cleanup();
          this.hasError = false;
          this.createPlayerWithHls();
        } catch (error) {
          this.hasError = true;
          this.showPlaybackDiagnosis(reason);
        }
      }, retryDelay);
    },

    handleHlsPlaybackError(reason, hls = window.hls) {
      if (this.isPlayerReady()) {
        this.scheduleStallRecovery(reason);
      } else {
        this.scheduleHlsInitializationRetry(hls, reason);
      }
    },

    showPlaybackDiagnosis(
      reason,
      video = this.getVideoElement(),
      mediaWasEmptied = this.mediaWasEmptied,
    ) {
      displayPlaybackDiagnosis(this, {
        video,
        reason,
        mediaWasEmptied,
      });
    },

    schedulePlaybackDiagnosis(reason, mediaWasEmptied = this.mediaWasEmptied) {
      if (this.playbackFailureTimer) clearTimeout(this.playbackFailureTimer);
      this.playbackFailureTimer = setTimeout(() => {
        this.playbackFailureTimer = null;
        const video = this.getVideoElement();
        const isHealthy = video
          && video.readyState >= 3
          && !video.ended;
        if (!isHealthy) {
          this.recordPlaybackDiagnosticEvent('recovery-failed', reason, {
            incident: true,
          });
          this.showPlaybackDiagnosis(reason, video, mediaWasEmptied);
        }
      // 完整重建後，HLS 可能仍在下載 manifest/segment；低速網路不應在 10 秒內被誤判為失敗
      }, 10000);
    },

    // 先嘗試恢復既有媒體連線，確認仍無法播放時才完整重建播放器
    async recoverPlayback(reason = 'playback') {
      const video = this.getVideoElement();
      if (
        !video
        || !this.hasVideo
        || !this.currentPlay.classCode
        || this.isCleaningUp
        || this.isRecoveringPlayback
      ) return;

      const playbackWasActive = this.playbackIntended
        || this.wasPlaying
        || (!video.paused && !video.ended);
      if (!playbackWasActive) return;

      // 避免同一個瀏覽器問題連續觸發多次重建
      if (Date.now() - this.lastPlaybackRecoveryAt < 3000) return;
      this.lastPlaybackRecoveryAt = Date.now();

      const recoveryClassCode = this.currentPlay.classCode;
      const recoveryItem = this.currentPlay;
      const recoveryRequestId = this.videoOpenRequestId;
      const recoveryTime = Number.isFinite(video.currentTime)
        ? video.currentTime
        : this.currentTime;
      const recoveryMediaWasEmptied = this.mediaWasEmptied;
      const shouldRebuildPlayer = reason === 'visibility' || reason === 'media-error';
      this.isRecoveringPlayback = true;
      this.clearPlaybackRecoveryTimers();
      this.recordPlaybackDiagnosticEvent('recovery-start', reason);

      try {
        // 輕量恢復先沿用現有授權與媒體連線，不因一般緩衝不足額外呼叫 Cookie API。
        if (
          this.videoOpenRequestId !== recoveryRequestId
          || this.currentPlay !== recoveryItem
          || this.currentPlay.classCode !== recoveryClassCode
          || !this.hasVideo
        ) return;

        if (this.isHlsReady()) {
          const { hls } = window;
          if (hls && hls.media !== video) hls.attachMedia(video);
          if (
            hls
            && reason === 'media-error'
            && typeof hls.recoverMediaError === 'function'
          ) {
            hls.recoverMediaError();
          }
          if (hls) hls.startLoad(recoveryTime);
        } else if (video.readyState === 0) {
          // 非 HLS 瀏覽器由原生 video 重新要求目前資源
          video.load();
          if (recoveryTime > 0) {
            try {
              video.currentTime = recoveryTime;
            } catch (error) {
              // metadata 尚未恢復時由 canplay 再套用觀看位置
            }
          }
        }

        if (this.isPlayerReady() && this.player.paused) {
          try {
            await this.player.play();
          } catch (error) {
            // 瀏覽器可能暫時禁止程式自動播放，後續仍會進入完整重建流程
          }
        }

        // 前景恢復依 PM 規格檢查 500ms；一般網路卡頓則給 HLS 較長時間重新下載。
        const recoveryCheckDelay = reason === 'visibility' ? 500 : 5000;
        await new Promise((resolve) => {
          setTimeout(resolve, recoveryCheckDelay);
        });

        const recoveredVideo = this.getVideoElement();
        if (
          this.videoOpenRequestId !== recoveryRequestId
          || this.currentPlay !== recoveryItem
          || this.currentPlay.classCode !== recoveryClassCode
          || !this.hasVideo
        ) return;
        const hasProgressed = recoveredVideo
          && recoveredVideo.currentTime > recoveryTime + 0.1;
        const isRecovered = recoveredVideo
          && recoveredVideo.readyState >= 3
          && !recoveredVideo.paused
          && !recoveredVideo.ended
          && hasProgressed;

        if (isRecovered) {
          this.hasError = false;
          this.mediaWasEmptied = false;
          this.playbackIntended = true;
          this.wasPlaying = true;
          this.recordPlaybackDiagnosticEvent('recovery-success', reason);
          return;
        }

        // 網路錯誤只做輕量 HLS 恢復；不要因網路不穩重新載入整個課程。
        if (!shouldRebuildPlayer) {
          this.recordPlaybackDiagnosticEvent('recovery-failed', reason, {
            incident: true,
          });
          this.showPlaybackDiagnosis(reason, recoveredVideo, recoveryMediaWasEmptied);
          return;
        }

        // 輕量恢復失敗才重建，並保留目前觀看位置與原本的播放意圖
        if (
          this.videoOpenRequestId !== recoveryRequestId
          || this.currentPlay !== recoveryItem
          || this.currentPlay.classCode !== recoveryClassCode
        ) return;

        const rebuildAccepted = await this.OpenVideo(recoveryItem, {
          isRecovery: true,
          preserveTime: recoveryTime,
          resume: playbackWasActive,
          showLoading: false,
        });
        // 若使用者在恢復期間切換了其他課程，舊恢復流程不得再操作新播放器。
        if (!rebuildAccepted || this.currentPlay.classCode !== recoveryClassCode) return;
        this.recordPlaybackDiagnosticEvent('player-rebuilt', reason);
        this.schedulePlaybackDiagnosis(reason, recoveryMediaWasEmptied);
      } catch (error) {
        this.recordPlaybackDiagnosticEvent(
          'recovery-failed',
          error && error.message ? error.message : reason,
          { incident: true },
        );
        this.showPlaybackDiagnosis(
          reason,
          this.getVideoElement(),
          recoveryMediaWasEmptied,
        );
      } finally {
        this.isRecoveringPlayback = false;
        this.mediaWasEmptied = false;
      }
    },

    // 完整釋放目前課程的播放器與原生媒體管線，供切課、重播及異常重建共用。
    cleanup() {
      this.recordPlaybackDiagnosticEvent('cleanup', '釋放 Plyr、HLS 與原生 video 資源');
      this.isCleaningUp = true;
      this.clearPlaybackRecoveryTimers();
      this.clearHlsInitializationRetryTimer();
      if (this.playbackPauseIntentTimer) {
        clearTimeout(this.playbackPauseIntentTimer);
        this.playbackPauseIntentTimer = null;
      }

      try {
        this.stopRealWatchTime();

        // destroy() 可能替換 video 節點，因此先保留舊節點，稍後新舊都做資源重置。
        const mediaBeforeDestroy = this.getVideoElement();

        if (this.isPlayerReady()) {
          this.removePlayerEvents(); // 確保事件被清理
          try {
            this.player.destroy();
          } catch (error) {
            // 第三方播放器清理失敗時仍要繼續釋放 HLS 與原生 video。
          } finally {
            this.player = null;
          }
        }

        const currentHls = window.hls;
        if (currentHls) {
          try {
            currentHls.off(Hls.Events.ERROR);
            currentHls.off(Hls.Events.MANIFEST_PARSED);
            currentHls.off(Hls.Events.FRAG_PARSING_INIT_SEGMENT);
            currentHls.off(Hls.Events.FRAG_PARSED);
            if (currentHls.media) currentHls.detachMedia();
            currentHls.destroy();
          } catch (error) {
            // HLS 清理失敗不能阻止原生媒體重置。
          } finally {
            // 即使第三方 destroy 發生例外，也不能讓下一堂誤用舊 HLS instance。
            window.hls = null;
          }
        }

        const mediaAfterDestroy = this.getVideoElement();
        [mediaBeforeDestroy, mediaAfterDestroy]
          .filter((video, index, videos) => video && videos.indexOf(video) === index)
          .forEach((video) => {
            // 只移除本播放器命名空間事件，不影響頁面上的其他 video。
            $(video).off('click.playerControl');
            this.resetMediaElement(video);
          });
      } finally {
        this.isCleaningUp = false;
        this.playbackIntended = false;
        this.wasPlaying = false;
        this.mediaWasEmptied = false;
      }
    },

    // ==================== 資料取得相關 ====================
    // 取得購買課程內容
    GetBuyCourseContent() {
      const { id } = this.$route.params;
      GetBuyCourseContentByMember({ courseId: id }).then((response) => {
        if (response.data.statusCode === 0) {
          try {
            this.data = response.data.data;
            this.$emit('update:currentPage', [
              {
                name: '',
                title: this.data.courseName,
                path: '',
              },
            ]);
            // 取出精選課程
            const classRoomList = this._.cloneDeep(this.data.classRoomList);
            // 取出自選課程
            const optionalClassRoomList = this._.flatMap(
              this._.cloneDeep(this.data.optionalClassRoomList),
              (item) => item.optionalClassRoomList,
            );

            // 已自選課程為主，保留兩邊重複的項目
            const intersection = this._.intersectionWith(
              optionalClassRoomList,
              classRoomList, (a, b) => a.subjectId === b.subjectId && a.teacherId === b.teacherId,
            );

            // 已精選課程為主，去除掉重複項目
            const unionData = this._.unionWith(classRoomList,
              optionalClassRoomList,
              (a, b) => a.subjectId === b.subjectId && a.teacherId === b.teacherId);

            // 將自選課程與精選課程重複的項目，加回去
            this._.forEach(intersection, (item) => {
              const data = this._.find(unionData,
                { subjectId: item.subjectId, teacherId: item.teacherId });
              data.buyCourseClassRoomList = data.buyCourseClassRoomList
                .concat(item.buyCourseClassRoomList);
            });

            // 再重新整理，將重複的classId剔除掉
            this._.forEach(unionData, (item) => {
              // eslint-disable-next-line no-param-reassign
              item.buyCourseClassRoomList = this._.uniqBy(item.buyCourseClassRoomList, 'classId');
            });

            this.$set(this.data, 'newClassRoomList', unionData);
            this.isReedy = true;
          } catch (error) {
            this.$router.replace('/error').catch();
          }
        } else this.$router.replace('/error').catch();
      });
    },

    // 取得影片觀看時間位置
    GetVideoTime(name, showLoading = false, isRequestCurrent = null) {
      return GetVideoTime({ name }, showLoading).then((response) => {
        if (isRequestCurrent && !isRequestCurrent()) return false;

        this.keepTime = 0;
        this.currentTime = 0;
        if (response.data.statusCode === 0) {
          this.currentTime = Math.floor(response.data.data);
          this.keepTime = this.currentTime;
        }
        return true;
      });
    },

    // 取得觀看影片的cookies
    GetVideoCookies(name, showLoading = false, isRequestCurrent = null) {
      const { id } = this.$route.params;
      this.recordPlaybackDiagnosticEvent('authorization-request', `classCode=${name}`);
      return GetVideoCookies({ courseId: id, name }, showLoading).then((response) => {
        if (isRequestCurrent && !isRequestCurrent()) return false;

        if (response.data.statusCode === 0) {
          const { data } = response.data;
          const expiresAt = getCloudFrontPolicyExpiration(data.policy);
          this.updatePlaybackAuthorizationDiagnostic({
            status: expiresAt ? '成功（已取得 Policy 到期時間）' : '成功（Policy 到期時間無法解析）',
            classCode: name,
            expiresAt,
          });
          document.cookie = `CloudFront-Policy=${data.policy};path=/; max-age=86400;`;
          document.cookie = `CloudFront-Key-Pair-Id=${data.keyPairId};path=/; max-age=86400;`;
          document.cookie = `CloudFront-Signature=${data.signature};path=/; max-age=86400;`;
          const { authorization } = this.playbackDiagnostics;
          const validityDetail = Number.isFinite(authorization.validitySeconds)
            ? `有效 ${authorization.validitySeconds} 秒`
            : '未取得有效秒數';
          this.recordPlaybackDiagnosticEvent('authorization-success', validityDetail);
        } else {
          const statusDetail = `statusCode=${response.data.statusCode}`;
          this.updatePlaybackAuthorizationDiagnostic({
            status: 'API 回傳失敗',
            classCode: name,
            error: statusDetail,
          });
          this.recordPlaybackDiagnosticEvent('authorization-error', statusDetail, {
            incident: true,
          });
        }
        return true;
      }).catch((error) => {
        const errorMessage = error && error.message ? error.message : 'GetVideoCookies request failed';
        this.updatePlaybackAuthorizationDiagnostic({
          status: '請求失敗',
          classCode: name,
          error: errorMessage,
        });
        this.recordPlaybackDiagnosticEvent('authorization-error', errorMessage, {
          incident: true,
        });
        throw error;
      });
    },

    // ==================== UI 互動相關 ====================
    // 切換課程
    ToggleClass(event) {
      if (
        event.target.className === 'side__box'
        || event.target.className.indexOf('gotolist__head') >= 0
        || event.target.className.indexOf('fa-chevron-up') >= 0
      ) event.currentTarget.classList.toggle('active');
    },
    // 開啟筆記
    async handleOpenNode(item2 = null) {
      if (
        item2 != null
        && (this.currentPlay.classCode === '' || this.currentPlay.classCode !== item2.classCode)
      ) {
        await this.OpenVideo(item2);
        this.showNote = 1;
      } else {
        this.showNote = 1;
      }
      if (item2 === null) {
        this.showNote = 2;
        this.handlePauseVideo();
      }
    },
    // 我的最愛
    handleFavorite(classInof) {
      if (classInof.hasVideo) {
        const { isFavorite, classCode, className } = classInof;
        const data = classInof;
        let func = AddToFavorite;
        if (isFavorite) {
          func = RemoveToFavorite;
        }
        func({ name: classCode }).then((res) => {
          if (res.data.statusCode === 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: `成功將${className}${isFavorite ? '移除' : '加入'}我的最愛`,
            });

            data.isFavorite = !isFavorite;
          }
        });
      }
    },
    // 變更筆記數量
    changeNoteCount(count) {
      this.currentPlay.videoNotesCount = count;
    },

    // ==================== 影片播放相關 ====================
    isPlayerReady() {
      return this.player && this.player !== null;
    },

    isHlsReady() {
      return window.hls && window.hls !== null;
    },
    shouldAutoSave() {
      return this.isPlayerReady()
        && this.player.playing // 檢查播放器狀態
        && !this.player.paused // 檢查是否暫停
        && this.realWatchStartTime;
    },
    // 開始真實觀看時間記錄
    startRealWatchTime() {
      // 確認播放器確實在播放
      if (!this.isPlayerReady() || !this.player.playing || this.player.paused) {
        // console.log('startRealWatchTime 取消 - 播放器未在播放狀態');
        return;
      }

      if (this.realWatchSaveTimer) {
        // console.log('停止舊的計時器');
        this.stopRealWatchTime();
      }

      this.realWatchStartTime = Date.now();
      // console.log('開始計時:', new Date().toLocaleTimeString());

      this.realWatchSaveTimer = setInterval(() => {
        // console.log('定時器檢查:', new Date().toLocaleTimeString());
        if (this.shouldAutoSave()) {
          const watchedSeconds = Math.floor((Date.now() - this.realWatchStartTime) / 1000);
          // console.log('已觀看秒數:', watchedSeconds);
          if (watchedSeconds >= 300) { // 每五分鐘自動儲存一次
            // console.log('準備保存 - 觀看時間:', watchedSeconds, '秒');
            this.SetVideoTime(
              this.currentPlay.classCode,
              Math.floor(this.player.currentTime),
              'AutoSave',
            );
            this.realWatchStartTime = Date.now(); // 重置計時器
            // console.log('重置計時器:', new Date().toLocaleTimeString());
          }
        }
      }, 60000); // 每分鐘檢查一次
    },
    // 停止真實觀看時間記錄
    stopRealWatchTime() {
      // console.log('停止計時:', new Date().toLocaleTimeString(), this.realWatchSaveTimer);
      if (this.realWatchSaveTimer) {
        clearInterval(this.realWatchSaveTimer);
        this.realWatchSaveTimer = null;
      }
    },
    // 重置真實觀看時間
    resetRealWatchTime() {
      this.realWatchStartTime = null;
    },

    // ==================== 播放器事件處理 ====================
    setupPlayerEvents() {
      if (!this.isPlayerReady()) return;

      // 移除所有舊的事件監聽器
      this.removePlayerEvents();

      // 重新設置事件監聽器
      this.player.on('error', this.handleError);
      this.player.on('play', this.handlePlay);
      this.player.on('pause', this.handleSaveVideoTime);
      this.player.on('canplay', this.canplay);
      this.player.on('ended', this.ended);
      this.player.on('playing', this.handlePlaybackHealthy);

      const video = this.getVideoElement();
      if (video) {
        video.addEventListener('emptied', this.handleMediaEmptied);
        video.addEventListener('waiting', this.handleMediaWaiting);
        video.addEventListener('stalled', this.handleMediaStalled);
        video.addEventListener('playing', this.handlePlaybackHealthy);
      }
    },
    removePlayerEvents() {
      if (this.isPlayerReady()) {
        this.player.off('error', this.handleError);
        this.player.off('play', this.handlePlay);
        this.player.off('pause', this.handleSaveVideoTime);
        this.player.off('canplay', this.canplay);
        this.player.off('ended', this.ended);
        this.player.off('playing', this.handlePlaybackHealthy);
        this.player.off('timeupdate', this.timeupdate);
        this.player.off('qualitychange');
        this.player.off('loadeddata');
      }

      const video = this.getVideoElement();
      if (video) {
        video.removeEventListener('emptied', this.handleMediaEmptied);
        video.removeEventListener('waiting', this.handleMediaWaiting);
        video.removeEventListener('stalled', this.handleMediaStalled);
        video.removeEventListener('playing', this.handlePlaybackHealthy);
      }
    },

    // ==================== Plyr 播放器初始化 ====================
    createPreferredPlayer() {
      const video = this.getVideoElement();
      if (this.shouldUseNativeHls(video) || !Hls.isSupported()) {
        this.createPlayerWithoutHls();
        return;
      }
      this.createPlayerWithHls();
    },

    // HLS 初始化部分
    createPlayerWithHls() {
      const video = this.getVideoElement();
      if (!video) return;

      const myStorage = window.localStorage;
      const quality = JSON.parse(myStorage.getItem('plyr') || '{"quality":720}');
      const Level = parseInt(quality.quality, 10) === 720 ? 0 : 1;

      const hls = new Hls({
        startLevel: Level,
        autoStartLoad: false,
        startPosition: this.currentTime,

        debug: false,
        enableWorker: true,
        lowLatencyMode: false,
        // maxLoadingDelay: 4,
        // 手機長時間播放時，過大的回溯區會增加媒體記憶體壓力
        backBufferLength: 30,
        // 保留適度的前置緩衝，兼顧網路波動與手機記憶體
        maxBufferLength: 45,
        // 50MB = 限制 HLS 緩衝區的記憶體使用量
        maxBufferSize: 50 * 1000 * 1000, // 50MB
        // 避免播放器長時間持續累積過多預載內容
        maxMaxBufferLength: 90,
      });

      // const rootUrl = `https://rp-bucket-streaming.s3-ap-northeast-1.amazonaws.com/m3u8/${this.currentPlay.classCode}`;
      const rootUrl = `/m3u8/${this.currentPlay.classCode}`;
      window.hls = hls;
      hls.loadSource(`${rootUrl}/${this.currentPlay.classCode}.m3u8`);
      this.recordPlaybackDiagnosticEvent('hls-init', `startLevel=${Level}`);

      // 立即監聽 fatal 錯誤（不等 MANIFEST_PARSED，提早捕捉初始化錯誤）
      hls.on(Hls.Events.ERROR, (event, data) => {
        if (window.hls !== hls) return;
        this.captureHlsErrorDiagnostic(data);
        if (data.fatal) {
          this.hasError = true;
          this.handleHlsPlaybackError(
            data.type === Hls.ErrorTypes.MEDIA_ERROR ? 'media-error' : 'network-error',
            hls,
          );
        }
      });

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        if (window.hls !== hls) return;
        this.clearHlsInitializationRetryTimer();
        this.hlsInitializationRetryCount = 0;
        this.hasError = false;
        this.recordPlaybackDiagnosticEvent(
          'hls-manifest',
          `levels=${hls.levels.map((level) => level.height).join(',')}`,
        );
        hls.startLoad(this.currentTime);
        this.setupHlsPlayer(hls, video);
      });
    },
    //  HLS Plyr 初始化邏輯
    setupHlsPlayer(hls, video) {
      const availableQualities = hls.levels.map((l) => l.height);
      const defaultOptions = {
        ...this.options,
        quality: {
          default: 720,
          options: availableQualities,
          forced: true,
          onChange: (e) => this.updateQuality(e),
        },
      };
      // 加入字幕軌-觀看者
      this.addCaptionTrack(video);
      // 建立 Plyr 播放器
      this.player = new Plyr(video, defaultOptions);
      // this.player.currentTime = this.currentTime;

      // 將 HLS.js 附加到 Plyr 的 video 元素
      hls.attachMedia(video);

      // 監聽 loadedmetadata 事件再設置時間
      video.addEventListener('loadedmetadata', () => {
        if (this.currentTime > 0) {
          this.player.currentTime = this.currentTime;
        }
      }, { once: true });

      // 設定事件
      this.setupPlayerEvents();
      // 設定影片點擊播放/暫停
      this.setupVideoClickHandler();
    },
    // HLS 的 Plyr 初始化部分
    createPlayerWithoutHls() {
      const video = this.getVideoElement();
      if (!video) return;
      const storedPlaybackSpeed = this.getStoredPlaybackSpeed();
      this.player = new Plyr(video, this.options);

      this.player.source = {
        type: 'video',
        sources: [
          { src: this.videoSource[0].src, size: 720 },
          { src: this.videoSource[1].src, size: 1080 },
        ],
        tracks: [{
          kind: 'captions',
          label: '觀看者',
          srclang: 'zh',
          src: this.captionsSrc,
          default: true,
        }],
      };
      this.restorePlaybackSpeedAfterSourceChange(this.player, storedPlaybackSpeed);
      this.recordPlaybackDiagnosticEvent(
        'native-init',
        this.shouldUseNativeHls(video)
          ? 'iOS 原生 HLS 優先'
          : 'Hls.isSupported()=false',
      );

      // 設置事件監聽器
      this.setupPlayerEvents();
      // 設定影片點擊播放/暫停
      this.setupVideoClickHandler();

      // 設置品質變更監聽器（先移除舊的，防止重複綁定）
      this.player.off('qualitychange');
      this.player.on('qualitychange', () => {
        this.player.off('timeupdate', this.timeupdate);
        this.player.off('canplay', this.canplay);
        this.player.on('canplay', this.canplay);
      });
    },
    // 建立字幕軌-觀看者
    addCaptionTrack(video) {
      if (!video) return;

      // 移除舊的字幕軌道
      const existingTrack = video.querySelector('track#trackZh');
      if (existingTrack) {
        video.removeChild(existingTrack);
      }

      // 創建新的字幕軌道
      const track = document.createElement('track');
      track.id = 'trackZh';
      track.kind = 'captions';
      track.label = '觀看者';
      track.srclang = 'zh';
      track.default = true;
      track.src = this.captionsSrc;

      video.appendChild(track);
      this.hasCaption = true;
    },
    // 設定影片點擊播放/暫停
    setupVideoClickHandler() {
      const video = this.getVideoElement();
      if (!video) return;

      const $video = $(video);

      // 移除之前綁定的播放器控制事件（不會影響其他事件）
      $video.off('click.playerControl');

      // 綁定新的播放器控制事件
      $video.on('click.playerControl', () => {
        if (this.isPlayerReady()) {
          if (this.player.playing) {
            this.playbackIntended = false;
            this.wasPlaying = false;
            this.player.pause();
          } else {
            this.playbackIntended = true;
            this.player.play();
          }
        }
      });
    },
    // 記錄影片觀看時間位置
    SetVideoTime(name, time, action = '') {
      if (time === 0 && action === '') {
        return;
      }

      // 計算真實觀看時間
      const totalSecond = this.realWatchStartTime
        ? Math.floor((Date.now() - this.realWatchStartTime) / 1000)
        : 0;

      // console.log(`SetVideoTime - Action: ${action}`);
      // console.log(`  影片播放位置: ${time}秒`);
      // console.log(`  實際觀看時間: ${totalSecond}秒`);
      // console.log(`  開始計時時間: ${this.realWatchStartTime ?
      //  new Date(this.realWatchStartTime).toLocaleTimeString() : 'null'}`);
      // console.log(`  當前時間: ${new Date().toLocaleTimeString()}`);

      const data = {
        name,
        time,
        action,
        TotalSecond: totalSecond,
        CourseId: this.data.courseId || '',
        ClassId: this.subject.classId || '',
      };
      SetVideoTime(data);
      this.currentPlay.time = Math.floor(time);
    },
    // 開啟影片
    async OpenVideo(item2, options = {}) {
      const {
        isRecovery = false,
        preserveTime = null,
        resume = false,
        // 初次開啟／切換課程保留全頁 Loading；播放中恢復則在背景處理。
        showLoading = !isRecovery,
      } = options;
      const openRequestId = this.videoOpenRequestId + 1;
      this.videoOpenRequestId = openRequestId;
      this.clearHlsInitializationRetryTimer();
      this.hlsInitializationRetryCount = 0;
      const isOpenRequestCurrent = () => openRequestId === this.videoOpenRequestId;

      // 記錄切換前的觀看時間
      if (!isRecovery && this.realWatchStartTime && this.currentPlay.classCode) {
        this.SetVideoTime(
          this.currentPlay.classCode,
          Math.floor(this.player ? this.player.currentTime : 0),
          'SwitchVideo',
        );
      }

      // 停止之前的計時
      this.stopRealWatchTime();
      if (!isRecovery) this.resetRealWatchTime();

      const { hasVideo, classCode } = item2;

      if (!isRecovery) {
        this.isRecoveringPlayback = false;
        this.clearPlaybackRecoveryTimers();
        this.playbackIntended = false;
        this.wasPlaying = false;
        this.resumeAfterRecovery = false;
      }

      // 恢復播放時先停止舊 HLS；一般切課維持原本時機，待課程 API 完成後由 handleLoadVideo 清理。
      if (isRecovery) {
        this.cleanup();
      } else if (this.isPlayerReady()) {
        // 新課程資料尚未完成前先保留舊播放器，避免 API 等待期間出現空白畫面。
        this.player.pause();
        this.player.off('timeupdate', this.timeupdate);
      } else if (this.isHlsReady()) {
        // manifest 尚未完成時沒有可保留的播放器，先釋放舊 HLS，避免失敗實例殘留。
        this.cleanup();
      }
      if (this.showNote !== 0) this.showNote = 0;

      if (hasVideo) {
        try {
          const cookieRequestApplied = await this.GetVideoCookies(
            classCode,
            showLoading,
            isOpenRequestCurrent,
          );
          if (!cookieRequestApplied || !isOpenRequestCurrent()) return false;

          const timeRequestApplied = await this.GetVideoTime(
            classCode,
            showLoading,
            isOpenRequestCurrent,
          );
          if (!timeRequestApplied || !isOpenRequestCurrent()) return false;
        } catch (error) {
          if (!isOpenRequestCurrent()) return false;
          this.hasError = true;
          this.showPlaybackDiagnosis('network-error');
          return false;
        }

        this.currentPlay = item2;
        this.recordPlaybackDiagnosticEvent(
          'course-selected',
          `${item2.className || ''} (${item2.classCode || ''})`,
        );
        if (isRecovery && Number.isFinite(preserveTime)) {
          this.currentTime = preserveTime;
          this.keepTime = preserveTime;
          this.resumeAfterRecovery = resume;
        }
        this.handleLoadVideo();
      } else {
        this.currentPlay = item2;
        this.recordPlaybackDiagnosticEvent(
          'course-selected',
          `${item2.className || ''}（尚無影片）`,
        );
        this.cleanup();
        this.$message({
          showClose: true,
          type: 'warning',
          message: '影片即將上架',
        });
      }
      this.hasVideo = hasVideo;

      this.subject = this._.cloneDeep(item2);
      return true;
    },
    // 切換影片清晰度
    updateQuality(newQuality) {
      if (window.hls && window.hls.levels) {
        window.hls.levels.forEach((level, levelIndex) => {
          if (level.height === newQuality) {
            window.hls.currentLevel = levelIndex;
          }
        });
      }
    },
    // 影片可以播放
    canplay() {
      if (!this.player) return;

      this.player.currentTime = this.currentTime;

      if (this.player.ended === true) {
        this.ended();
        return;
      }

      if (this.player.currentTime === this.currentTime) {
        this.player.off('canplay', this.canplay);
        this.player.off('timeupdate', this.timeupdate);
        this.player.on('timeupdate', this.timeupdate);
      }

      if (this.resumeAfterRecovery && !this.player.ended) {
        this.resumeAfterRecovery = false;
        this.playbackIntended = true;
        this.player.play().catch(() => {
          // 自動播放被瀏覽器阻擋時，保留播放器可由使用者手動播放的狀態
        });
      }

      const video = this.getVideoElement();
      if (document.pictureInPictureElement && video) {
        video.requestPictureInPicture();
      }
    },
    // 影片播放完畢
    ended() {
      this.recordPlaybackDiagnosticEvent('ended', '影片自然播放完畢');
      // 停止真實觀看時間記錄
      this.stopRealWatchTime();
      this.clearPlaybackRecoveryTimers();
      this.wasPlaying = false;
      this.playbackIntended = false;
      this.mediaWasEmptied = false;
      this.resumeAfterRecovery = false;

      // 重置播放狀態
      this.keepTime = 0;
      this.currentTime = 0;

      // 記錄影片播放完畢
      this.SetVideoTime(this.currentPlay.classCode, 0, 'EndVideo');
      this.currentPlay.isLook = true;
      this.resetRealWatchTime();

      // 同時釋放 Plyr 與 HLS，避免重播時殘留舊 MediaSource／下載器。
      this.cleanup();
      this.hlsInitializationRetryCount = 0;

      // 重新初始化播放器（為了重播功能）
      this.reinitializePlayerAfterEnd();
    },
    // 播放結束後重新初始化播放器
    reinitializePlayerAfterEnd() {
      // 重置播放時間為開始位置
      this.currentTime = 0;

      this.createPreferredPlayer();
    },
    // 影片長度時間更新 (撥放器事件)
    timeupdate() {
      if (this.isPlayerReady()) {
        this.currentTime = this.player.currentTime;
      }
    },
    // 顯示沒有提供下載檔案訊息
    ShowMsgForNotDownloadFile() {
      this.$message({
        showClose: true,
        type: 'warning',
        message: `${this.currentPlay.className} 暫時沒有提供`,
      });
    },
    // 變更影片播放時間
    changeCurrentTime(time) {
      if (this.isPlayerReady()) {
        this.player.currentTime = parseInt(time, 10);
      }
    },
    // 暫停影片
    handlePauseVideo() {
      if (this.isPlayerReady()) {
        this.playbackIntended = false;
        this.wasPlaying = false;
        this.player.pause();
      }
    },
    schedulePlaybackPauseIntentReset() {
      if (this.playbackPauseIntentTimer) clearTimeout(this.playbackPauseIntentTimer);
      const pausedVideo = this.getVideoElement();
      this.playbackPauseIntentTimer = setTimeout(() => {
        this.playbackPauseIntentTimer = null;
        if (
          !pausedVideo
          || pausedVideo !== this.getVideoElement()
          || this.isCleaningUp
          || this.isRecoveringPlayback
          || this.hasError
          || this.mediaWasEmptied
          || pausedVideo.error
          || !pausedVideo.paused
          || pausedVideo.ended
        ) return;

        this.playbackIntended = false;
        if (!document.hidden) this.wasPlaying = false;
        this.recordPlaybackDiagnosticEvent('pause', '播放器已暫停');
        this.stopPlaybackProgressWatch();
        if (this.playbackLightRecoveryTimer) {
          clearTimeout(this.playbackLightRecoveryTimer);
          this.playbackLightRecoveryTimer = null;
        }
      }, 100);
    },
    // 暫停就記錄
    handleSaveVideoTime() {
      // console.log('handleSaveVideoTime 觸發 - 播放器狀態:', {
      //   playerReady: this.isPlayerReady(),
      //   paused: this.player?.paused,
      //   hasTimer: !!this.realWatchSaveTimer,
      // });

      this.schedulePlaybackPauseIntentReset();

      if (this.isPlayerReady()) {
        // 只有在有計時器的情況下才執行保存邏輯
        if (this.realWatchSaveTimer) {
          this.stopRealWatchTime();

          this.SetVideoTime(
            this.currentPlay.classCode,
            Math.floor(this.player.currentTime),
            'Pause',
          );

          this.keepTime = this.player.currentTime;
          this.currentTime = this.player.currentTime;
          this.resetRealWatchTime();
        } else {
          // console.log('handleSaveVideoTime 跳過 - 沒有活動的計時器');
        }
      }
    },
    // 影片錯誤
    handleError() {
      if (this.isPlayerReady()) {
        this.player.off('timeupdate', this.timeupdate);
      }
      this.hasError = true;
      const video = this.getVideoElement();
      const errorCode = video && video.error ? video.error.code : 'unknown';
      this.recordPlaybackDiagnosticEvent('media-error', `MediaError=${errorCode}`, {
        incident: true,
      });
      this.scheduleStallRecovery('media-error');
    },
    // 影片播放
    async handlePlay() {
      if (this.playbackPauseIntentTimer) {
        clearTimeout(this.playbackPauseIntentTimer);
        this.playbackPauseIntentTimer = null;
      }
      this.playbackIntended = true;
      this.wasPlaying = true;
      this.recordPlaybackDiagnosticEvent('play', '使用者或恢復流程要求播放');
      if (this.isRecoveringPlayback) return;

      const playRequestId = this.videoOpenRequestId;
      const playClassCode = this.currentPlay.classCode;
      const isPlayRequestCurrent = () => (
        playRequestId === this.videoOpenRequestId
        && this.currentPlay.classCode === playClassCode
      );

      // 防止重複執行（快速按 K/空白鍵造成多個 async 並行）
      if (this.isHandlingPlay) return;
      this.isHandlingPlay = true;

      try {
        if (!this.isHlsReady()) {
          const cookieRequestApplied = await this.GetVideoCookies(
            playClassCode,
            false,
            isPlayRequestCurrent,
          );
          if (!cookieRequestApplied || !isPlayRequestCurrent()) return;

          if (this.hasError) {
            this.hasError = false;
            const timeRequestApplied = await this.GetVideoTime(
              playClassCode,
              false,
              isPlayRequestCurrent,
            );
            if (!timeRequestApplied || !isPlayRequestCurrent()) return;
            this.player.off('canplay', this.canplay);
            this.player.on('canplay', this.canplay);
            const video = this.getVideoElement();
            if (video) {
              this.resumeAfterRecovery = true;
              video.load();
            }
          }
        } else {
          // eslint-disable-next-line no-lonely-if
          if (this.hasError) {
            const video = this.getVideoElement();
            const recoveryTime = video && Number.isFinite(video.currentTime)
              ? video.currentTime
              : this.currentTime;
            this.hasError = false;
            await this.OpenVideo(this.currentPlay, {
              isRecovery: true,
              preserveTime: recoveryTime,
              resume: true,
              showLoading: false,
            });
          } else {
            const cookieRequestApplied = await this.GetVideoCookies(
              playClassCode,
              false,
              isPlayRequestCurrent,
            );
            if (!cookieRequestApplied || !isPlayRequestCurrent()) return;
            // 只有 HLS media 真的脫離時才需要重新 attach + startLoad
            // 正常暫停後繼續播放不需要呼叫 startLoad，避免反覆中斷 segment 載入
            if (window.hls && !window.hls.media) {
              const video = this.getVideoElement();
              if (video) {
                window.hls.attachMedia(video);
                window.hls.startLoad(this.currentTime);
              }
            }
          }
        }

        // 延遲檢查播放狀態，確保播放器狀態已更新
        setTimeout(() => {
          if (this.isPlayerReady() && this.player.playing && !this.player.paused) {
            if (!this.realWatchSaveTimer) {
              this.startRealWatchTime();
            }
          }
        }, 100);
      } catch (error) {
        if (isPlayRequestCurrent()) {
          this.recordPlaybackDiagnosticEvent(
            'recovery-failed',
            error && error.message ? error.message : '播放請求失敗',
            { incident: true },
          );
          const video = this.getVideoElement();
          if (!video || video.readyState < 2 || this.hasError) {
            this.showPlaybackDiagnosis('network-error', video);
          }
        }
      } finally {
        this.isHandlingPlay = false;
      }
    },
    // 載入影片
    handleLoadVideo() {
      if (this.showNote !== 0) this.showNote = 0;
      // const rootUrl = `https://rp-bucket-streaming.s3-ap-northeast-1.amazonaws.com/m3u8/${this.currentPlay.classCode}`;
      const rootUrl = `/m3u8/${this.currentPlay.classCode}`;
      this.videoSource[0].src = `${rootUrl}/${this.currentPlay.classCode}_720.m3u8`;
      this.videoSource[1].src = `${rootUrl}/${this.currentPlay.classCode}_1080.m3u8`;

      this.cleanup();

      // 重置錯誤狀態
      this.hasError = false;

      this.createPreferredPlayer();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep html {
  --plyr-color-main: #0096a4;
}

::v-deep video {
  height: 100% !important;
  width: 100% !important;
}

::v-deep .plyr {
  height: 100% !important;
  width: 100% !important;
}

::v-deep .playing {
  position: absolute;
  top: 13px;
  left: 10px;
}

::v-deep .comingsoon {
  text-shadow: -1px -1px 1px #c0c4cc, 1px 1px 1px #fff;
  color: #fff !important;
}

::v-deep div[role='menu'] {
  max-height: 100px;
  overflow-x: auto;
}

::v-deep .LearningInfo {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
}

::v-deep .plyr__video-wrapper::before {
  position: absolute;
  color:#ffffff;
  // color: #161515;
  top: 50%;
  left: 3%;
  z-index: 10;
  pointer-events: none;
  content: var(--content);
  height: 100%;
  width: 93%;
  // background: right 35%/10% no-repeat url(https://www.i-readerplace.com/img/footer_logo.bb3c350c.png);
  opacity: 0.1;
  font-size: 90%;
}
::v-deep .plyr__caption {
  opacity: 0.2;
  background: none;
}
::v-deep .plyr__captions {
  // bottom: var(--bottom);
  // text-align: var(--text-align);
  top: 0;
  text-align: left;
  pointer-events: none;
  transform: none !important;
}
</style>
